import { NgModule } from "@angular/core";
import { CustomLoaderComponent } from './custom-loader.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CustomLoaderService } from './custom-loader.service';
import { MaterialModule } from '../material.module';

@NgModule({
    declarations: [CustomLoaderComponent],
    imports: [
        CommonModule,
        IonicModule,
        MaterialModule
    ],
    providers: [
        CustomLoaderService
    ],
    exports: [CustomLoaderComponent]
})
export class CustomLoaderModule {}